import { useMutation } from '@tanstack/react-query';
import { getAuthHeaders } from '../../utils/authHeaders';
import { getCurrentGatewayUrl } from '../../utils/environmentDetection';

type BulkNeoRunInput = {
  applicationId: string;
  signalIds: string[];
};

export type BulkNeoRunResponse = {
  results: Array<{
    signalId: string;
    success: boolean;
    threadId: string | null;
    executionId: string | null;
    queued?: boolean;
    alreadyRunning?: boolean;
    error?: string;
  }>;
};

export function useBulkNeoRun() {
  return useMutation({
    mutationFn: async ({
      applicationId,
      signalIds,
    }: BulkNeoRunInput): Promise<BulkNeoRunResponse> => {
      const authHeaders = await getAuthHeaders();
      const response = await fetch(
        `${getCurrentGatewayUrl()}/ai/agents/neo/run/bulk`,
        {
          method: 'POST',
          credentials: 'include',
          headers: {
            'Content-Type': 'application/json',
            ...authHeaders,
          },
          body: JSON.stringify({
            signalIds,
            applicationId,
          }),
        },
      );

      if (!response.ok) {
        throw new Error('Failed to start Neo');
      }

      return (await response.json()) as BulkNeoRunResponse;
    },
  });
}
